'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress } from '../../ProgressIndicator';
import { styled } from '@mui/material/styles';
export const StyledLoadingDiv = styled('div')(({ theme }) => ({
    padding: `${theme.tokens.FuelSpacing4} 0px`,
    textAlign: 'center',
    lineHeight: theme.tokens.FuelSpacing6,
    '& .MuiSvgIcon-root ': {
        marginRight: theme.tokens.FuelSpacing1,
        verticalAlign: 'bottom'
    },
    '& .MuiCircularProgress-root ': {
        marginRight: theme.tokens.FuelSpacing2,
        verticalAlign: 'bottom',
        height: '24px !important',
        width: '24px !important'
    }
}));
export const getLoadingStatusView = (status) => status ? {
    loading: (_jsxs(StyledLoadingDiv, { children: [_jsx(CircularProgress, { size: 'small' }), 'Loading items...'] })),
    searching: (_jsxs(StyledLoadingDiv, { children: [_jsx(CircularProgress, { size: 'small' }), 'Searching items...'] })),
    empty: (_jsxs(StyledLoadingDiv, { children: [_jsx(SearchIcon, {}), 'No items found'] }))
}[status] : null;
